import React from "react";
import { Box, Image, Flex, Text, Button, Badge } from "@chakra-ui/react";
import { PlayIcon } from "./playicon";
import { CertificateIcon } from "./certificate-icon";
import { useTranslation } from "react-i18next";
import { useCertificateContext } from "@root/context/certificate-context";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import { formatDateToISO } from "@root/utils/date-helper";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";

const DEFAULT_THUMBNAIL = defaultThumbnail;

interface MobileCompletedCourseProps {
  course: any;
  completedAt?: any;
}

const MobileCompletedCourse: React.FC<MobileCompletedCourseProps> = ({
  course,
  completedAt,
}) => {
  const { t } = useTranslation("common");
  const { fetchCertificate, isCertificateLoading } = useCertificateContext();
  const navigate = useNavigate();

  return (
    <Box
      w="100%"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="#CDD6DC"
      bg="white"
      overflow="hidden"
      mb="16px"
    >
      <Flex direction="row" gap="16px" p="16px">
        {/* Image */}
        <Box
          w="120px"
          h="120px"
          flexShrink={0}
          borderRadius="12px"
          overflow="hidden"
        >
          <Image
            src={course?.thumbnail || DEFAULT_THUMBNAIL}
            objectFit="contain"
            w="100%"
            h="100%"
          />
        </Box>

        {/* Content */}
        <Flex direction="column" flex="1" gap="8px">
          {/* Title */}
          <Text
            fontSize="16px"
            fontWeight="600"
            color="#2F2F34"
            lineHeight="1.2"
            noOfLines={2}
          >
            {course?.title}
          </Text>

          {/* Completion Date */}
          <Text fontSize="14px" color="#5C6670">
            {t("certificateSection.completed")}:{" "}
            {completedAt ? formatDateToISO(completedAt) : "-"}
          </Text>

          {/* Issued Badge */}
          <Badge
            mt={"12px"}
            bg="#F0F9F7"
            color="#00A177"
            borderRadius="16px"
            px="12px"
            py="4px"
            fontSize="12px"
            fontWeight="600"
            border="1px solid #00A177"
            w="fit-content"
            textTransform="none"
          >
            {t("course.issued")}
          </Badge>
        </Flex>
      </Flex>

      {/* Action Buttons */}
      <Flex p="16px" gap="12px" width={"100%"}>
        {/* Re Watch Button */}
        <Button
          width={"40%"}
          variant="outline"
          borderColor="#1819B4"
          color="#1819B4"
          bg="transparent"
          borderRadius="8px"
          h="40px"
          fontSize="14px"
          fontWeight="500"
          leftIcon={<PlayIcon boxSize={4} color="#1819B4" />}
          onClick={() =>
            navigate(`${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${course?.id}`)
          }
          _hover={{
            bg: "#F0F0FF",
          }}
        >
          {t("certificateSection.Re-watch")}
        </Button>

        {/* Download Certificate Button */}
        <Button
          width={"60%"}
          bg="#1819B4"
          color="white"
          borderRadius="8px"
          h="40px"
          fontSize="14px"
          fontWeight="500"
          leftIcon={<CertificateIcon boxSize={4} color="white" />}
          onClick={() =>
            fetchCertificate({
              courseId: course?.id,
              gmtOffset: 0,
            })
          }
          isLoading={isCertificateLoading(course?.id)}
          loadingText={t("certificateSection.download")}
          disabled={isCertificateLoading(course?.id)}
          _hover={{ bg: "#1415A0" }}
        >
          {t("certificateSection.download")}
        </Button>
      </Flex>
    </Box>
  );
};

export default MobileCompletedCourse;
